import { create } from 'zustand';
import funnelJourneyConfig from './funnel-journey-config.json';

type FunnelJourneyKey =
  | keyof typeof funnelJourneyConfig.journeys
  | keyof typeof funnelJourneyConfig.manageBookingJourneys
  | keyof typeof funnelJourneyConfig.checkinJourneys
  | '';

export type FunnelJourneyStepForStore = {
  id: string;
  fieldKey: string;
  iconId: string;
  className?: string;
  url: string;
  renderInProgressBar: boolean;
};

export type PostBookingJourneyStepForStore = {
  id: string;
  url: string;
};

export type FunnelJourneyGroupSteps = FunnelJourneyStepForStore[] | PostBookingJourneyStepForStore[];

type FunnelJourneyConfigData = {
  key: FunnelJourneyKey;
  steps: FunnelJourneyGroupSteps;
  currentStepIndex?: number;
  nextPageUrl?: string;
};
type FunnelJourneyConfigState = Partial<FunnelJourneyConfigData> & {
  setConfig: (value: FunnelJourneyConfigData) => void;
  setCurrentStepIndex: (currentStepIndex: number) => void;
};

const DEFAULT_NEXT_PAGE_URL = '';

export const useFunnelJourneyConfigStore = create<FunnelJourneyConfigState>((set, get) => ({
  key: '',
  steps: [],
  currentStepIndex: 0,
  nextPageUrl: DEFAULT_NEXT_PAGE_URL,

  setConfig: (values: FunnelJourneyConfigData) => {
    const { currentStepIndex } = get();
    const { key, steps } = values;
    const isValidNextStep = currentStepIndex !== undefined && steps.length > 1 && steps[currentStepIndex + 1];
    const nextPageUrl = isValidNextStep ? steps[currentStepIndex + 1].url : DEFAULT_NEXT_PAGE_URL;
    set(state => ({ ...state, key, steps, currentStepIndex, nextPageUrl }));
  },

  setCurrentStepIndex: (currentStepIndex: number) => {
    const { steps } = get();
    const isValidNextStep = steps && steps.length > 1 && steps[currentStepIndex + 1];
    const nextPageUrl = isValidNextStep ? steps[currentStepIndex + 1].url : DEFAULT_NEXT_PAGE_URL;
    set(state => ({ ...state, currentStepIndex, nextPageUrl }));
  }
}));

export default useFunnelJourneyConfigStore;
